import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from '../../Sidebar.module.scss';

type SubmenuItemProps = {
  link: string;
  title: string;
  setCurrentOpenMenuBlock: (link: string) => void;
  activeSubmenuItem: string;
  onLinkClick?: (link: string) => void;
};

export const SubmenuMenuItem = ({
  link,
  title,
  setCurrentOpenMenuBlock,
  activeSubmenuItem,
  onLinkClick,
}: SubmenuItemProps) => {
  useEffect(() => {
    if (window.location.href.includes(link)) {
      setCurrentOpenMenuBlock(link);
    }
  }, []);

  const handleClick = () => {
    setCurrentOpenMenuBlock(link);
    onLinkClick?.(link);
  };

  return (
    <li
      key={title}
      className={classNames({
        [styles.submenuItemActive]: activeSubmenuItem === link,
      })}
    >
      {link.startsWith('/react') ? (
        <Link to={link.slice(6)} onClick={handleClick}>
          {title}
        </Link>
      ) : (
        <a href={link}>{title}</a>
      )}
    </li>
  );
};
